/*
* Thème: STACK
*/

window.HeaderSearch_PluginInit = function() {
	var search_form = $('.footer + .search-form__container')
	$('.js-search').parent().append(search_form.html())

	$('.js-search').click(function() {
		$('body').toggleClass('--search-open')
		$('footer + .search-form__container .search-form__input').focus().select()
		if ($('body').hasClass('--search-open')) {
			$('.search-form__container button, .search-form__container input').attr('tabindex', '2')
		} else {
			$('.search-form__container button, .search-form__container input').attr('tabindex', '-1')
		}
		return false;
	})

	$('.search-form__toggle').click(function() {
		$('body').removeClass('--search-open')
		return false;
	})

	$('body').click(function(e) {
		if ($(e.target).closest('.search-form__container').length == 0 && $(e.target).closest('.search-form__toggle').length == 0) {
			$('body').removeClass('--search-open')
		}
	});
}

/* End: STACK */
